<template>
  <va-edit-layout :actions="['list', 'show', 'delete']">
    <farm-events-form :id="id" :title="title" :item="item"></farm-events-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ['id', 'title', 'item'],
}
</script>
